import { Badge } from "@mui/material";

interface NotificationBadgeType {
  hasNotification: boolean | undefined;
}

export default function NotificationBadge({ hasNotification }: NotificationBadgeType) {
  return <Badge overlap="circular" badgeContent=" " variant="dot" color="error" sx={{ position: "absolute", top: 2, right: 4 }} invisible={!hasNotification} />;
}
